
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/tagesplan",
      function () {
        return require("private-next-pages/[domain]/tagesplan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/tagesplan"])
      });
    }
  